import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppStore } from '../../store/useAppStore'
import { Icon } from '../ui/Icon'
import { Button } from '../ui/Button'

interface WidthToggleButtonProps {
  className?: string
}

export const WidthToggleButton: React.FC<WidthToggleButtonProps> = ({ className = '' }) => {
  const { t } = useTranslation()
  const isFullWidth = useAppStore(state => state.isFullWidth)
  const toggleFullWidth = useAppStore(state => state.toggleFullWidth)

  return (
    <Button
      onClick={toggleFullWidth}
      variant="secondary"
      size="sm"
      className={`gap-2 ${className}`}
      aria-label={isFullWidth ? t('view.standardWidth') : t('view.fullWidth')}
      title={isFullWidth ? t('view.standardWidth') : t('view.fullWidth')}
    >
      <Icon name={isFullWidth ? 'width-standard' : 'width-full'} size={16} />
      <span className="hidden lg:inline">
        {isFullWidth ? t('view.standardWidth') : t('view.fullWidth')}
      </span>
    </Button>
  )
}
